import { CHANGE_VALUES } from './constants';
import { IChangeType } from './types';

export const getNumWithPostfixString = (value: number | string, postfix: string) => {
  return `${value} ${postfix}`;
};

export const getRegexMatchString = (value: string, regex: RegExp, postfix: string) => {
  let displayText = value;
  if (!regex.test(value)) {
    const num = parseInt(value);
    if (!isNaN(num)) {
      displayText = getNumWithPostfixString(num, postfix);
    } else {
      displayText = getNumWithPostfixString(0, postfix);
    }
  }

  return displayText;
};

export const changeCounterOnAdornmentClick = (value: string, change: IChangeType, shift: number = 1, maxValue: number = 10000, minValue: number = 0) => {
  let num = parseInt(value);

  if (isNaN(num)) {
    num = 0;
  }

  if (change === CHANGE_VALUES.ADD) {
    if (num + shift > maxValue) return num
    num += shift;
  } else {
    if (num - shift < minValue) return num
    num -= shift;
    if (num < 0) num = 0;
  }

  return num;
};
